import Image from 'next/image';

const RANK_BADGES: Record<number, string> = {
  1: '/images/dgr/leaderboard/rank-1st.svg',
  2: '/images/dgr/leaderboard/rank-2nd.svg',
  3: '/images/dgr/leaderboard/rank-3rd.svg',
};

export function RankBadge({ rank }: { rank: number }) {
  const badge = RANK_BADGES[rank];

  if (badge) {
    return <Image src={badge} alt={`Rank ${rank}`} width={36} height={36} className="w-9 h-9" />;
  }

  return (
    <div className="w-8 h-8 rounded-full bg-stone-100 flex items-center justify-center">
      <span className="text-stone-600 text-sm font-medium">{rank}</span>
    </div>
  );
}
